/**
 * This is a composition function that returns the shop configuration.
 * It wraps useShopConfiguration and makes sure, that the shop configuration
 * is only fetched once.
 */
export default (key = 'useShopConfiguration') => {
  const { data, status, refresh } = useShopConfiguration(
    { options: { immediate: false } },
    key,
  )

  const fetch = async () => {
    // no need to fetch again if shop configuration is already fetched
    if (data.value || status.value === 'pending') {
      return
    }

    await refresh()
  }

  return {
    data,
    status,
    fetch,
    isActiveSalePeriod: computed(() => isShopActiveSalePeriod(data.value)),
  }
}
